/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'download-file': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M833.47 337.03c-29.25-149.88-160.85-263.2-321.7-263.2-160.84 0-292.44 113.32-321.69 263.2C80.42 366.28 0 468.63 0 585.61c0 142.57 113.32 255.9 255.89 255.9h36.56v-73.12h-36.56c-102.35 0-182.78-80.42-182.78-182.78 0-102.35 80.42-182.78 182.78-182.78 0-142.57 113.32-255.89 255.89-255.89s255.9 113.32 255.9 255.89c102.35 0 182.78 80.42 182.78 182.78s-80.42 182.78-182.78 182.78h-36.56v73.12h36.56c142.57 0 255.89-113.33 255.89-255.9-.01-116.98-80.44-219.33-190.1-248.58zm0 0" _fill="#fff"/><path pid="1" d="M484.653 942.423c14.63 10.97 29.24 14.63 43.87 7.31 3.65 0 7.31-3.65 10.97-7.31l109.67-106.01c14.62-14.63 14.62-36.56 0-51.18-14.63-14.63-40.21-14.63-54.84 0l-43.86 40.21v-310.73c0-21.93-18.28-36.55-36.56-36.55-21.93 0-36.55 18.27-36.55 36.55v310.74l-43.87-40.21c-14.62-14.63-40.21-14.63-54.83 0-14.63 14.62-14.63 36.55 0 51.18l106 106zm0 0" _fill="#fff"/>'
  }
})
